<template>
    <form @submit.prevent="updatePassword">
        <FormSection>
            <template #title>
                Update Password
            </template>
            <template #description>
                Ensure your account is using a long, random password to stay secure.
            </template>

            <FormGroup
                name="current_password"
                label="Current Password">
                <InputEl
                    type="password"
                    v-model="form.current_password"
                    ref="current_password"
                    autocomplete="current-password"
                    required/>
            </FormGroup>

            <FormGroup
                name="password"
                label="New Password">
                <InputEl
                    type="password"
                    v-model="form.password"
                    required
                    autocomplete="new-password"/>
            </FormGroup>

            <FormGroup
                name="password_confirmation"
                label="Confirm Password">
                <InputEl
                    type="password"
                    v-model="form.password_confirmation"
                    required
                    autocomplete="new-password"/>
            </FormGroup>

            <template #footer>
                <ActionMessage
                    :on="form.recentlySuccessful"
                    class="mr-3">
                    Saved.
                </ActionMessage>
                <SubmitButton
                    :submitting="form.processing"
                    :disabled="form.errors.any()">
                    Update
                </SubmitButton>
            </template>
        </FormSection>
    </form>
</template>

<script>
import FormSection from "@/Components/Form/FormSection";
import FormGroup from "@/Components/Form/FormGroup";
import InputEl from "@/Components/Form/Input";
import ActionMessage from "@/Components/ActionMessage";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    data() {
        return {
            form: this.$form({
                current_password: '',
                password: '',
                password_confirmation: '',
            }, {resetOnSuccess: true}),
        }
    },

    provide() {
        return {
            form: this.form,
        }
    },

    components: {
        FormSection,
        FormGroup,
        InputEl,
        ActionMessage,
        SubmitButton
    },

    methods: {
        updatePassword() {
            this.form.put(route('user-password.update'))
            .then(() => {
                this.$notify.success('Password updated.');
            })
            .catch(console.error)
        },
    }
}
</script>
